import { useAuth0 } from "@auth0/auth0-react";
import Fade from "@material-ui/core/Fade";
import Dialog from "@mui/material/Dialog";
import PreSchoolService from "Lib/API/PreSchool";
import BackIcon from "assets/icons/Back.png";
import AlertDialog from "components/Dialog/index";
import ShareDocumentsModal from "pages/NewFinance/Documents/ShareDocumentsModal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation, useParams } from "react-router-dom";
import AddParticipantModal from "./AddParticipantModal/AddParticipantModal";
import ParticipantDetailsTable from "./ParticipantDetailsTable/ParticipantDetailsTable";
import { ButtonGroup, ClassInfo, Header, Title, Wrapper } from "./Theme";

const MembershipDetails = () => {
  const [openFilter, setOpenFilter] = useState(false);
  const history = useHistory();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const [loading, setLoading] = useState(false);
  const [participantsPage, setParticipantsPage] = useState(1);
  const [count, setCount] = useState();
  const [rows, setRows] = useState([]);
  const [renderCount, setRenderCount] = useState(0);
  const [openAddParticipant, setOpenAddParticipant] = useState(false);
  const [openSharePaymentModal, setOpenSharePayment] = useState(false);
  const [dataRowSharePayment, setDataRowSharePayment] = useState({});
  const [dataRowsSharePayment, setDataRowsSharePayment] = useState([]);
  const [isMultipleSharePayment, setIsMultipleSharePayment] = useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [confirmClose, setConfirmClose] = useState(false);
  const [getFormLoading, setGetFormLoading] = useState(false);
  const [formInfo, setFormInfo] = useState({});
  const [sorting, setSorting] = useState({
    sort: {},
    search: undefined,
  });

  const dispatch = useDispatch();
  const [addParticipantLoading, setAddParticipantLoading] =
    React.useState(false);

  const { id: formId } = useParams();
  const participantGroupId = searchParams.get("groupId");

  // const [filter, setFilter] = useState({
  //     sort: {},
  //     search:undefined
  // });
  const { getAccessTokenSilently } = useAuth0();

  const getFormHandler = async () => {
    setGetFormLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const response = await PreSchoolService.getMemberShipForm(token, formId);
      const data = response?.result;
      setFormInfo(data);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong");
    } finally {
      setGetFormLoading(false);
    }
  };
  useEffect(() => {
    if (formId) {
      getFormHandler();
    }
  }, [formId, getAccessTokenSilently]);

  const getFormParticipants = async (page) => {
    const currentPage = page || participantsPage;
    setLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const data = {
        formId,
        ...sorting,
      };
      if (participantGroupId) {
        data.groupId = participantGroupId;
      }
      const response = await PreSchoolService.getFormMembers(token, data);
      setCount(response.payload?.pagination?.count);
      setRows(response?.payload?.data);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  const handleOpenFilter = () => {
    setOpenFilter(!openFilter);
  };
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const regex = /[\*\(\)\+]/;
    if (!regex.test(inputValue)) {
      setSearchValue(inputValue);
    }
  };
  //   const handleSort = (name) => {
  //     setSorting((prev) => ({
  //       ...prev,
  //       sort: {
  //         [name]: prev.sort[name] === 1 ? -1 : 1,
  //       },
  //     }));
  //   };

  useEffect(() => {}, [openFilter]);

  const addParticipantHandler = async ({
    contactId,
    doNotCreateCharge,
    firstName,
    lastName,
  }) => {
    setAddParticipantLoading(true);
    const token = await getAccessTokenSilently();
    const payload = {
      formId,
      contactId,
      doNotCreateCharge,
    };
    PreSchoolService.addParticipantToClass(token, payload)
      .then((response) => {
        toastr.success(
          "Success",
          `${firstName} ${lastName} added to ${formInfo?.formName}`
        );
        setOpenAddParticipant(false);
        getFormParticipants();
      })
      .catch((error) => {
        toastr.error("Error", error?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setAddParticipantLoading(false);
      });
  };

  const onSharePaymentLinkClick = (row) => {
    setOpenSharePayment((prev) => !prev);
    setDataRowSharePayment(row);
    setIsMultipleSharePayment(false);
  };
  const onSharePaymentLinkMultipleClick = (rows) => {
    setOpenSharePayment((prev) => !prev);
    setIsMultipleSharePayment(true);
    setDataRowsSharePayment(rows);
  };
  useEffect(() => {
    if (searchValue === "") {
      setSorting({ ...sorting, search: undefined });
    } else {
      setSorting({ ...sorting, search: searchValue });
    }
    setParticipantsPage(1);
  }, [searchValue]);

  const closeModal = () => {
    setConfirmClose(true);
  };
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenAddParticipant(false);
  };

  return (
    <Wrapper className="mt-10">
      <Header>
        <ClassInfo>
          <Title>
            <img
              src={BackIcon}
              alt="Back"
              onClick={() => history.push("/forms?key=membership")}
            />
            {formInfo?.formName}
          </Title>
          <ButtonGroup></ButtonGroup>
        </ClassInfo>
      </Header>
      <ParticipantDetailsTable
        getFormParticipants={getFormParticipants}
        sorting={sorting}
        setSorting={setSorting}
        setParticipantsPage={setParticipantsPage}
        participantsPage={participantsPage}
        count={count}
        setCount={setCount}
        rows={rows}
        setRows={setRows}
        loading={loading}
        formId={formId}
        setRenderCount={setRenderCount}
        onSharePaymentLinkClick={onSharePaymentLinkClick}
        onSharePaymentLinkMultipleClick={onSharePaymentLinkMultipleClick}
        handleInputChange={handleInputChange}
        searchValue={searchValue}
        participantGroupId={participantGroupId}
      />
      <Dialog
        className={``}
        onClose={closeModal}
        open={openAddParticipant}
        PaperProps={{
          style: {
            width: "500px",
            height: "400px",
            overflowX: "hidden",
            borderRadius: "10px",
          },
        }}
        fullWidth
  TransitionComponent={Fade}
        maxWidth={"md"}
      >
        
          <AddParticipantModal
            closeModal={closeModal}
            formId={formId}
            addParticipantHandler={addParticipantHandler}
            addParticipantLoading={addParticipantLoading}
          />
       
      </Dialog>
      {openSharePaymentModal && (
        <Dialog
          open={openSharePaymentModal}
          onClose={() => {
            setOpenSharePayment(false);
          }}
          PaperProps={{
            style: {
              width: "888px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <ShareDocumentsModal
            closeModal={() => {
              setOpenSharePayment(false);
            }}
            type={"sharePaymentLink"}
            sharePaymentType={"form"}
            accountId={
              !isMultipleSharePayment ? dataRowSharePayment?.account?._id : ""
            }
            accountName={
              !isMultipleSharePayment
                ? dataRowSharePayment?.account?.family_name
                : ""
            }
            participantId={
              !isMultipleSharePayment ? dataRowSharePayment?._id : ""
            }
            defaultEmail={
              !isMultipleSharePayment && dataRowSharePayment?.email
                ? [dataRowSharePayment?.email]
                : []
            }
            isMultiple={isMultipleSharePayment}
            // isMultipleTypes={true}
            participantsIds={
              isMultipleSharePayment
                ? dataRowsSharePayment?.map((row) => row?._id)
                : []
            }
            documentType="paymentLink"
          />
        </Dialog>
      )}
      <AlertDialog
        open={confirmClose}
        handleClose={() => setConfirmClose(false)}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </Wrapper>
  );
};

export default MembershipDetails;
